<script setup>
import SpeedyFooter from '@/components/SpeedyFooter.vue';
import SearchField from '@/components/SearchField.vue';
import HistoricalTimetables from '@/components/HistoricalTimetables.vue';
</script>
<template>
    <div>
        <search-field></search-field>
        <router-view ref="router-view"></router-view>
        <speedy-footer></speedy-footer>
        <historical-timetables v-if="historicalTimetablesEnabled" />
    </div>
</template>
<script>
import eggs, { startEggListener } from '@/eggs.js';

export default {
    data() {
        return { eggs }
    },
    computed: {
        historicalTimetablesEnabled() {
            return this.eggs.historicalTimetables;
        }
    },
    mounted() {
        startEggListener();
    }
}
</script>